export const counterLabel = 'Участники встречи';
